import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteTimeClock } from 'api/admin/timeClock/deleteTimeClock'
import { timeClockKeys } from './keys'

export function useDeleteTimeClockMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteTimeClock,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: timeClockKeys.all })
    },
  })
}
